import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { submitVisit as submitVisitActions } from '../actions';
import { SUBMIT_VISIT } from '../constants/actionTypes';
import * as api from '../repository';


function *_submitVisit(action) {
    const {trac} = action;
    yield put(loadDataAction('submitVisit'));

    try {
        let response = yield call(api.submitVisit(trac));
        yield put(submitVisitActions.success(response));
        yield put(loadDataSuccessAction('submitVisit', 'visit.submit.success'));
    } catch (error) {
        yield put(submitVisitActions.error(error));
        yield put(loadDataErrorAction('submitVisit', {response: error.response, body: error.body, titleId:'visit.submit.failed'}, action));
    }

}


export function *submitVisit() {
    yield takeLatest(SUBMIT_VISIT.REQUEST, _submitVisit);
}